<script>
import moment from "moment/moment";
import {authenticated, SendRequest} from "./APIService";
import {showModal} from "./Modal";
import {UserData} from "./UserStore";

let logs = [];

let currentPage = 1;
let pageSize = 30;


function getSupportUserHistory(){
    SendRequest(
        "GetAllSupportLogsByUserId",
        "GET",
        "supportUser=" + $authenticated.user + "&page=" + currentPage + "&pageSize=" + pageSize,
        (response) => {
            console.log("get all history Called");
            logs = response.supportLogs;
        },
        (error) => {
            showModal("Error", "failed to get history", "OK");
            logs = [];
        }
    );
}

function nextPage(){
    currentPage++;
    getSupportUserHistory();
}

function previousPage(){
    if (currentPage != 1){
        --currentPage;
        getSupportUserHistory();
    }
}

let keys = [];
let values = [];

$: {
    keys = [];
    values = [];
    for (const [key, value] of Object.entries(logs)) {
        keys = [...keys, key];
        values = [...values, value];
        console.log(`${key}: ${value}`);
    }
}



$: getSupportUserHistory();

</script>


<br>
<br>
<br>

<div class="row justify-content-md-center">
    <div class="card col-md-8">
        <div class="card-header">
            <h5 class="card-header" style="text-align: center;"><h3>Logs History</h3></h5>
        </div>
        <div class="card-body">


                <div class="mb-3 input-group">
                    {#if currentPage != 1}
                    <button class="btn btn-danger col-form-label" type="button" on:click={previousPage}>PreviousPage</button>
                    {/if}
                    <label  class="col-2 form-control" style="text-align: center"> Page {currentPage}</label>
                    {#if keys.length >= pageSize }
                    <button class="btn btn-danger col-form-label" type="button" on:click={nextPage}>NextPage</button>
                    {/if}
                </div>





            {#if keys.length > 0 }
                <table class="table table-bordered table-hover">
                    <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Action</th>
                        <th scope="col">Details</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each values as prop, index}
                        <tr>
                            <td>
                                { moment(new Date(prop.timestamp)).from(new Date())}
                            </td>
                            <td>
                                {prop.action}
                            </td>
                            <td>
                                {prop.details}
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            {/if}
        </div>
    </div>

</div>

<br>
<br>
<br>



<style>

</style>